export const fairAvailabilityStatus = {
  REGISTERED: 'Registered',
  FULL: 'Full',
  CLOSED: 'Closed',
  OPEN: 'Open',
};

function getFairAvailabilityStatus(collegeFair) {
  if (collegeFair && (collegeFair.attending === 'PENDING' || collegeFair.attending === 'APPROVED')) {
    return fairAvailabilityStatus.REGISTERED;
  }
  if (collegeFair && (collegeFair.currentColleges >= collegeFair.maxColleges)) {
    return fairAvailabilityStatus.FULL;
  }
  if (collegeFair && (collegeFair.hasRsvpDeadlinePassed)) {
    return fairAvailabilityStatus.CLOSED;
  }
  return fairAvailabilityStatus.OPEN;
}

export function getFairAvailabilityAction(collegeFair) {
  const status = getFairAvailabilityStatus(collegeFair);
  const fairAction = {};
  switch (status) {
    case fairAvailabilityStatus.REGISTERED:
      fairAction.disabled = true;
      fairAction.label = 'Registered';
      break;
    case fairAvailabilityStatus.FULL:
      fairAction.disabled = true;
      fairAction.label = 'Full';
      break;
    case fairAvailabilityStatus.CLOSED:
      fairAction.disabled = true;
      fairAction.label = 'Closed';
      break;
    default:
      fairAction.disabled = false;
      fairAction.label = 'Register';
  }
  return fairAction;
}
